import $ from 'jquery';

$( document ).on( 'ready', function() {
	const $wrapper = $( '.js-post-items-wrapper' );

	if ( $wrapper && $wrapper.length ) {
		const loading = window.securelist2020Data.loading;

		let doingAjax = false;

		$wrapper
		.on( 'click', '.js-load-more', function( event ) {
			event.preventDefault();
	
			const $postsWrapper = $( '.js-post-items' );
			const $button = $( this );
	
			$button.attr( 'disabled', true );
	
			if ( ! doingAjax ) {
				$.ajax( {
					url: $button.attr( 'href' ),
					method: 'get',
					data: {
						'securelist-2020-ajax': 'true',
					},
					beforeSend: function() {
						doingAjax = true;
						$button.text( loading );
					},
					success: function( data ) {
						const $container = $( $.parseHTML( data ) );
						const $posts = $container.find( '.js-post-item' );

						let offsetX = window.pageXOffset;
						let offsetY = window.pageYOffset;

						if ( $posts.length ) {
							for (let i = 0; i < $posts.length; i++) {
								if ( ! $( $posts[i] ).hasClass( 'js-post-item-has-divider' ) && 0 === i ) {
									$postsWrapper.append( '<hr class="c-list-group__divider" />' );
								}

								$postsWrapper.append( $posts[i] );

								if ( ! $( $posts[i] ).hasClass( 'js-post-item-has-divider' ) && ( i + 1 ) % 3 === 0 && ( i + 1 ) < $posts.length ) {
									$postsWrapper.append( '<hr class="c-list-group__divider" />' );
								}
							}
	
							const $newButton = $container.find( '.js-load-more' );
		
							if ( $newButton.length ) {
								$button.before( $newButton );
							}
						}

						window.scrollTo( offsetX, offsetY );

						$button.remove();
						doingAjax = false;
					},
					error: function() {
						$button.remove();
						doingAjax = false;
					}
				} );
			}
		} );
	}

	// Comments.
	const $commentsWrapper = $( '.js-comments-wrapper' );

	if ( $commentsWrapper && $commentsWrapper.length ) {
		const loading = window.securelist2020Data.loading;

		$commentsWrapper
		.on( 'click', '.js-load-comments', function( event ) {
			event.preventDefault();
	
			const $commentsWrapper = $( '.js-comments' );
			const $button = $( this );
	
			$button.attr( 'disabled', true );
	
			let doingAjax = false;
	
			if ( ! doingAjax ) {
				$.ajax( {
					url: $button.attr( 'href' ),
					method: 'get',
					data: {
						'securelist-2020-ajax': 'true',
					},
					beforeSend: function() {
						doingAjax = true;
						$button.text( loading );
					},
					success: function( data ) {
						const $container = $( $.parseHTML( data ) );
						const $comments = $container.find( '.js-comment' );

						if ( $comments.length ) {
							$commentsWrapper.append( $comments );
	
							const $newButton = $container.find( '.js-load-comments' );
		
							if ( $newButton.length ) {
								$button.before( $newButton );
							}
						}

						$button.remove();
						doingAjax = false;
					},
					error: function() {
						$button.remove();
						doingAjax = false;
					}
				} );
			}
		} );
	}
} );
